import { useState } from 'react';
import { FormControl, FormLabel, Text, Stack, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from '@/components/forms/new/formikFormFields/BooleanToggle';
import TriggerFieldToolTip from './TriggerFieldToolTip';
import { useTriggerForm } from '../useTriggerForm.js';
import { FORM_FIELD_PATHS } from '../triggerFormConstants.js';
import walkthroughIds from '../../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const HtmlBodyToggle = ({ darkMode }) => {
    const { editMode } = walkthroughIds;
    const [isHovered, setIsHovered] = useState(false);

    // Use context instead of Redux
    const { formData, updateFormData } = useTriggerForm();

    const handleToggleChange = (value) => {
        updateFormData(FORM_FIELD_PATHS.HTML_BODY, value);
    };

    return (
        <FormControl
            sx={{ margin: '0 !important', position: 'relative' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel
                        htmlFor={FORM_FIELD_PATHS.HTML_BODY}
                        sx={formLabelStyling(darkMode)}>
                        HTML Body
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Enable HTML formatting for the email body content.
                    </Text>
                </Box>
                <Box flex={1} paddingTop="30px">
                    <Field
                        component={BooleanToggle}
                        id={FORM_FIELD_PATHS.HTML_BODY}
                        name={FORM_FIELD_PATHS.HTML_BODY}
                        isChecked={formData?.action?.htmlBody ?? false}
                        onChange={handleToggleChange}
                        walkthroughId={editMode.ufHtmlBodyCheckbox}
                    />
                    <TriggerFieldToolTip
                        isVisible={isHovered}
                        label="Enable this option to use HTML formatting in the email body. This allows for rich text, links, images, and custom styling."
                        ariaLabel="html-body-toggle-tip"
                    />
                </Box>
            </Stack>
        </FormControl>
    );
};

export default HtmlBodyToggle;
